import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";

import { ProgramEquipment } from "../../types/service.type";

const VideoEquipments = ({ equipments }: { equipments: ProgramEquipment }) => {
  const { t } = useTranslation("goService", { keyPrefix: "programVideoDetailsPage" });
  const { t: tEquipments } = useTranslation("goService", { keyPrefix: "equipments" });
  const ballControlAndAgilityEquipments = equipments.ball_control_and_agility;
  const strengthAndPowerEquipments = equipments.strength_and_power;
  const enduranceAndSpeedEquipments = equipments.endurance_and_speed;
  const rehabilitationAndRecoveryEquipments = equipments.rehabilitation_and_recovery;
  const specializedTrainingEquipments = equipments.specialized_training;

  const hasNoEquipments =
    !ballControlAndAgilityEquipments.length &&
    !strengthAndPowerEquipments.length &&
    !enduranceAndSpeedEquipments.length &&
    !rehabilitationAndRecoveryEquipments.length &&
    !specializedTrainingEquipments.length;
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{t("equipmentsNeeded")}</Typography>
      {hasNoEquipments && <Typography sx={styles.noEquipments}>{t("noEquipments")}</Typography>}
      {ballControlAndAgilityEquipments.length > 0 && (
        <CategoryEquipments
          categoryTitle={tEquipments("ball_control_and_agility")}
          equipments={ballControlAndAgilityEquipments}
        />
      )}
      {strengthAndPowerEquipments.length > 0 && (
        <CategoryEquipments categoryTitle={tEquipments("strength_and_power")} equipments={strengthAndPowerEquipments} />
      )}
      {enduranceAndSpeedEquipments.length > 0 && (
        <CategoryEquipments
          categoryTitle={tEquipments("endurance_and_speed")}
          equipments={enduranceAndSpeedEquipments}
        />
      )}
      {rehabilitationAndRecoveryEquipments.length > 0 && (
        <CategoryEquipments
          categoryTitle={tEquipments("rehabilitation_and_recovery")}
          equipments={rehabilitationAndRecoveryEquipments}
        />
      )}
      {specializedTrainingEquipments.length > 0 && (
        <CategoryEquipments
          categoryTitle={tEquipments("specialized_training")}
          equipments={specializedTrainingEquipments}
        />
      )}
    </Box>
  );
};

const CategoryEquipments = ({ categoryTitle, equipments }: { categoryTitle: string; equipments: string[] }) => {
  const { t: tEquipments } = useTranslation("goService", { keyPrefix: "equipments" });

  return (
    <Box sx={styles.categoryContainer}>
      <Typography sx={styles.categoryTitle}>{categoryTitle}</Typography>
      <Box sx={styles.equipmentsWrapper}>
        {equipments.map((equipment) => (
          <Chip key={equipment} label={equipment} sx={styles.equipmentChip} />
        ))}
      </Box>
    </Box>
  );
};

export default VideoEquipments;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #1D2026)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  equipmentChip: {
    color: "var(--Green---100, #008B07)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "4px 12px",
    backgroundColor: "var(--Green---25, #E7EFED)",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
  categoryContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  categoryTitle: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #1D2026)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",
  },
  equipmentsWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  noEquipments: {
    color: "var(--Gray-500, #667085)",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
};
